/**
 * @generated SignedSource<<d24f6c140d42068c5e6b2e2124e5c416>>
 * @relayHash 1f4934278e75a88d3eb69c312f4d3781
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5d4fbfc9c3080c6ddafa129455f44a71c3ff0f28a6a1724d405ac1f07da8a914

import type { ConcreteRequest } from 'relay-runtime';
export type useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery$variables = {
  accountIds?: ReadonlyArray<string> | null;
  contentIds: ReadonlyArray<string>;
  startTime: string;
};
export type useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery$data = {
  readonly contentAnalyticsLastViewedAtByPage: {
    readonly nodes: ReadonlyArray<{
      readonly contentId: string;
      readonly lastViewedAt: string;
    } | null> | null;
  } | null;
};
export type useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery = {
  response: useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery$data;
  variables: useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTime"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountIds",
        "variableName": "accountIds"
      },
      {
        "kind": "Variable",
        "name": "contentIds",
        "variableName": "contentIds"
      },
      {
        "kind": "Variable",
        "name": "startTime",
        "variableName": "startTime"
      }
    ],
    "concreteType": "ContentAnalyticsLastViewedAtByPage",
    "kind": "LinkedField",
    "name": "contentAnalyticsLastViewedAtByPage",
    "plural": false,
    "selections": [
      {
        "concreteType": "ContentAnalyticsLastViewedAtByPageItem",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "contentId"
          },
          {
            "kind": "ScalarField",
            "name": "lastViewedAt"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "1f4934278e75a88d3eb69c312f4d3781",
    "id": "5d4fbfc9c3080c6ddafa129455f44a71c3ff0f28a6a1724d405ac1f07da8a914",
    "metadata": {},
    "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
    "operationKind": "query",
    "text": "query useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery($contentIds:[ID!]!,$startTime:String!,$accountIds:[ID!]){contentAnalyticsLastViewedAtByPage(contentIds:$contentIds,startTime:$startTime,accountIds:$accountIds){nodes{contentId,lastViewedAt}}}"
  }
};
})();

(node as any).hash = "badbeccf002cdee0d8b5fac46d07c0f2";

export default node;
